import { useState } from 'react';
import { Button } from '@mui/material';
import { UploadFile as UploadFileIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';

import UploadCoaDialog from './UploadCoaDialog';

const UploadCoaButton = ({ onUploaded }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant='contained'
        color='primary'
        startIcon={<UploadFileIcon />}
        onClick={() => setOpen(true)}
        sx={{ height: 33 }}
      >
        Upload COA
      </Button>
      <UploadCoaDialog open={open} onClose={() => setOpen(false)} onUploaded={onUploaded} />
    </>
  );
};

UploadCoaButton.propTypes = {
  onUploaded: PropTypes.func,
};

UploadCoaButton.defaultProps = {
  onUploaded: undefined,
};

export default UploadCoaButton;
